/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-control[_ngcontent-%COMP%]{font-size:14px;height:48px;margin-top:8px;margin-bottom:8px;border-radius:25px}.btn-primary[_ngcontent-%COMP%]{background-color:#1b76bb;color:#fff}.btn[_ngcontent-%COMP%]{font-weight:500;font-size:16px;border-radius:25px;padding:8px 24px;border:none}.img-rounded[_ngcontent-%COMP%]{border-radius:30px!important}.captcha[_ngcontent-%COMP%]{width:150px}.text-primary[_ngcontent-%COMP%]{color:#1b76bb!important}.set-border[_ngcontent-%COMP%]{border:2px solid #1b76bb!important}"];
export { styles as styles };
